<template>
  <div></div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'Logout',
  mounted () {
    this.$http.post('/auth/logout').then(() => {
      window.localStorage.setItem('token', '');
      window.localStorage.setItem('user', JSON.stringify({
        type: 'USER'
      }))
      Vue.prototype.$http.defaults.headers.common.Authorization = 'Bearer none';
      this.$nextTick(function () {
        this.$router.push({ name: 'Logowanie' });
      })
    }).catch((error) => {
      console.log(error);
      window.localStorage.setItem('token', '');
      window.localStorage.setItem('user', {});
      Vue.prototype.$http.defaults.headers.common.Authorization = 'Bearer none';
      this.$router.push({ name: 'Logowanie' });
    });
  }
}
</script>
